import styled from "styled-components";

import FlexBox from "../FlexBox";
import { DAVYS_GREY_400, DAVYS_GREY_600 } from "../colors";

const DateDivider = styled(FlexBox)`
  width: 100%;
  align-items: center;
  column-gap: 0.75rem;
  margin: 0.25rem 0;
`;

const DateDividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${DAVYS_GREY_400};
`;

const DateDividerLabel = styled.span`
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1rem;
  color: ${DAVYS_GREY_600};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
`;

const AiChatMessageDateDivider = ({ label }) => (
  <DateDivider>
    <DateDividerLine />
    <DateDividerLabel>{label}</DateDividerLabel>
    <DateDividerLine />
  </DateDivider>
);

export default AiChatMessageDateDivider;
